import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 640.000000 640.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,640.000000) scale(0.100000,-0.100000)"
        >
          <path d="M1800 4445 c-14 -16 -3 -20 19 -6 8 5 9 11 3 15 -5 3 -15 -1 -22 -9z"/>
<path d="M1956 4424 c-9 -8 -20 -13 -26 -9 -6 4 -7 -1 -3 -11 5 -13 3 -15 -7
-9 -9 6 -11 4 -5 -4 5 -9 15 -5 36 15 16 15 29 29 29 31 0 7 -10 2 -24 -13z"/>
<path d="M1754 4394 c-4 -10 -22 -38 -41 -61 -19 -24 -29 -43 -23 -43 6 0 13
7 16 15 9 22 23 18 17 -4 -5 -21 -29 -35 -43 -26 -19 12 -182 -294 -211 -396
-7 -24 -16 -48 -20 -54 -12 -17 -66 -236 -81 -325 -22 -142 -17 -422 11 -570
56 -296 180 -572 364 -810 70 -91 257 -275 347 -342 157 -117 367 -228 540
-287 354 -121 782 -134 1140 -35 99 28 223 76 320 124 157 78 184 94 320 196
99 74 126 99 144 136 6 12 18 23 26 26 9 3 7 -2 -5 -12 -20 -17 -20 -17 1 -7
28 14 47 38 39 51 -10 16 -28 12 -21 -6 3 -9 2 -12 -5 -9 -6 4 -8 13 -6 19 3
7 -3 19 -14 26 -15 11 -16 17 -6 29 7 9 1 7 -15 -4 -15 -11 -28 -23 -28 -26 0
-10 -145 -119 -230 -174 -201 -130 -424 -217 -695 -271 -110 -23 -480 -26
-585 -5 -297 57 -525 148 -755 299 -245 162 -458 405 -586 667 -120 248 -179
532 -165 805 5 119 32 299 57 385 24 85 101 276 139 345 22 40 40 76 40 81 0
4 3 9 8 11 4 2 23 28 42 58 19 30 43 64 53 75 10 11 24 29 29 40 21 38 -18 -2
-58 -61 -21 -31 -40 -51 -42 -44 -2 6 2 17 8 25 8 10 9 15 2 15 -13 0 -26 -36
-17 -50 3 -5 2 -10 -3 -10 -5 0 -12 -9 -15 -20 -3 -11 -11 -20 -19 -20 -8 0
-9 3 -2 8 16 11 23 37 13 53 -5 8 -9 9 -9 3 0 -7 -11 -9 -25 -6 -14 2 -25 0
-25 -5 0 -5 -6 -17 -12 -26 -11 -15 -13 -13 -14 15 -1 18 1 27 3 20 7 -19 33
5 33 30 0 11 9 22 20 25 11 3 21 13 21 22 1 9 2 23 3 31 1 8 9 30 19 48 10 19
16 36 13 39 -3 3 -9 -3 -12 -13z m-61 -319 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2
15 9 16 15 13 8 -4z m2842 -2115 c3 -5 -1 -10 -10 -10 -9 0 -13 5 -10 10 3 6
8 10 10 10 2 0 7 -4 10 -10z"/>
<path d="M1761 4313 c-1 -6 -4 -20 -7 -30 -5 -17 -5 -17 6 0 6 10 9 23 6 30
-3 9 -5 9 -5 0z"/>
<path d="M4968 4143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4890 4133 c-49 -18 -98 -44 -110 -58 -11 -13 -10 -19 6 -38 10 -12
20 -23 20 -25 1 -2 20 8 42 22 22 14 62 31 89 38 26 7 40 14 30 16 -9 2 -15 8
-12 13 4 5 -4 9 -17 10 -13 0 -17 3 -10 6 6 2 12 9 12 14 0 10 -26 11 -50 2z"/>
<path d="M4940 3993 c-14 -2 -39 -15 -55 -28 l-30 -23 23 -25 c23 -24 24 -25
64 -9 37 15 44 15 90 -2 50 -17 50 -17 74 5 l24 22 -32 24 c-33 24 -91 44
-118 41 -8 0 -26 -3 -40 -5z"/>
<path d="M4934 3825 c-18 -27 -13 -54 16 -80 41 -37 115 18 89 67 -16 30 -28
38 -61 38 -18 0 -33 -8 -44 -25z"/>
<path d="M3664 3510 c-68 -10 -74 -15 -74 -56 l0 -35 78 6 c103 9 132 -2 132
-50 l0 -35 -72 0 c-125 0 -203 -51 -215 -141 -15 -107 89 -162 205 -109 34 16
42 16 42 5 0 -12 14 -15 60 -15 46 0 58 3 54 13 -3 8 4 67 16 132 28 167 27
209 -8 245 -46 46 -106 57 -218 40z m114 -243 c1 -4 2 -21 2 -37 0 -41 -48
-72 -105 -68 -37 3 -40 5 -43 36 -4 40 10 59 52 71 34 10 90 9 94 -2z"/>
<path d="M3056 3485 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M3212 3453 c-6 -27 -21 -101 -33 -165 l-22 -117 -43 -7 c-52 -7 -84
8 -84 41 0 13 4 57 10 97 18 140 19 160 7 150 -7 -6 -30 -8 -52 -6 -33 2 -41
0 -42 -14 -1 -9 -11 -62 -22 -117 -28 -137 -27 -176 5 -208 44 -44 146 -49
267 -12 32 9 60 22 62 28 3 13 44 275 50 327 2 16 0 30 -5 30 -6 0 -10 -10
-10 -22 0 -31 -15 -54 -25 -38 -4 6 -13 9 -20 6 -7 -2 -16 2 -19 10 -10 26 -7
52 7 57 7 4 6 6 -5 6 -12 1 -19 -12 -26 -46z"/>
<path d="M3400 3492 c0 -4 -9 -50 -19 -102 -11 -52 -27 -140 -37 -195 -22
-130 -32 -145 -88 -145 l-44 0 -4 -42 c-3 -24 0 -46 6 -51 17 -12 117 3 151
22 57 33 69 64 103 277 18 110 32 209 32 222 0 20 -5 22 -50 22 -27 0 -50 -4
-50 -8z m83 -9 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m4 -19
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M2110 3459 c-8 -19 -17 -36 -20 -39 -4 -3 -46 -81 -94 -173 l-87
-168 67 3 66 3 26 62 27 63 107 0 107 0 3 -62 3 -63 63 -3 c52 -2 62 0 62 14
0 28 -41 338 -47 354 -4 12 -7 11 -13 -5 -4 -13 -19 -22 -41 -25 -33 -5 -34
-6 -37 -57 l-3 -53 -73 0 -73 0 1 29 c1 16 4 27 7 26 3 -2 12 15 21 39 13 35
13 43 2 43 -8 0 -14 -7 -14 -15 0 -8 -8 -20 -17 -27 -15 -11 -19 -9 -30 12
-10 19 -10 29 -2 39 6 7 9 19 7 25 -2 7 -10 -3 -18 -22z"/>
<path d="M4457 3483 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M5258 3473 c6 -2 10 -9 6 -14 -3 -5 0 -9 5 -9 6 0 11 5 11 10 0 6 6
10 13 10 6 -1 1 -10 -12 -20 l-23 -20 23 1 c26 0 72 17 51 18 -7 1 -11 5 -8
10 7 11 -18 21 -52 20 -15 0 -21 -3 -14 -6z"/>
<path d="M2538 3461 c0 -3 -2 -10 -3 -16 -1 -5 -5 -17 -8 -25 -11 -26 -58
-311 -53 -319 9 -14 91 -31 149 -31 144 0 237 88 263 250 10 64 1 85 -42 87
-20 1 -41 8 -46 15 -6 10 -10 10 -18 -2 -9 -13 -10 -13 -10 0 0 10 -11 16 -31
17 -18 1 -43 10 -56 18 -14 9 -27 14 -30 11 -3 -3 2 -8 11 -12 13 -5 14 -9 5
-20 -16 -20 -30 -17 -22 4 6 16 5 16 -14 0 -11 -10 -24 -18 -29 -18 -5 0 -2 5
6 11 11 8 8 9 -14 4 -25 -5 -28 -4 -18 8 10 12 8 15 -13 19 -14 3 -26 2 -27
-1z m213 -50 c19 -16 23 -27 21 -67 -5 -126 -66 -198 -153 -179 -25 6 -30 11
-26 28 3 12 13 65 23 119 17 93 18 96 48 106 47 15 62 14 87 -7z"/>
<path d="M3240 3450 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M4168 3453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2295 3439 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M2808 3443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4109 3445 c-1 -3 -3 -9 -4 -15 -1 -5 -3 -13 -4 -17 -1 -5 -5 -2 -10
6 -6 9 -8 6 -8 -11 l0 -25 21 21 c12 12 17 24 12 27 -4 4 -2 9 5 12 10 4 10 6
2 6 -7 1 -14 -1 -14 -4z"/>
<path d="M4845 3440 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4330 3425 c0 -7 -6 -18 -13 -22 -8 -4 -17 -16 -20 -27 -5 -12 -14
-17 -27 -13 -14 4 -20 0 -21 -11 0 -15 -1 -15 -7 1 -5 11 -12 -12 -20 -65 -14
-89 -29 -111 -84 -123 -63 -14 -96 29 -84 110 7 44 3 51 -27 46 -5 -1 -6 9 -2
21 4 16 3 19 -3 9 -8 -11 -10 -11 -15 0 -3 8 -3 -4 -1 -26 l4 -40 -13 40 c-7
22 -9 42 -5 43 4 2 6 8 2 13 -12 20 -22 -3 -18 -39 3 -25 2 -31 -4 -18 -8 19
-9 19 -16 1 -14 -38 -18 -133 -7 -167 19 -58 54 -83 114 -83 29 1 68 9 87 18
31 16 36 16 46 2 7 -10 27 -15 58 -15 45 0 46 1 46 33 0 17 7 68 15 112 9 44
13 95 10 113 -3 19 -2 39 3 45 16 20 24 57 13 57 -6 0 -11 -7 -11 -15z"/>
<path d="M4568 3433 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5462 3380 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4040 3350 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4859 3297 c-34 -162 -15 -206 94 -214 70 -6 63 -11 83 57 4 17 1 20
-23 20 -15 0 -33 4 -40 8 -19 12 -25 55 -13 106 9 42 8 50 -7 61 -9 7 -23 11
-29 8 -7 -2 -21 0 -32 6 -18 10 -21 6 -33 -52z"/>
<path d="M5441 3355 c-1 -6 -19 -18 -41 -28 -23 -10 -40 -24 -40 -33 0 -13 -3
-14 -14 -5 -8 7 -17 8 -20 3 -3 -6 3 -12 13 -15 18 -4 18 -9 9 -47 -9 -35 -18
-45 -54 -63 -62 -30 -98 -17 -102 37 -2 23 2 42 9 46 6 5 8 13 4 21 -6 9 -11
6 -17 -11 -5 -12 -11 -21 -13 -18 -3 3 2 22 11 43 14 35 14 37 -1 31 -9 -3
-18 -6 -21 -6 -2 0 -1 -6 2 -14 3 -7 -2 -16 -11 -20 -9 -3 -13 -2 -10 4 3 6 0
10 -9 10 -24 0 -56 -63 -56 -109 0 -55 14 -80 55 -97 47 -19 89 -18 135 6 47
24 60 25 60 5 0 -11 13 -15 53 -15 l52 0 4 58 c2 31 4 73 5 92 2 19 6 46 10
60 4 14 3 37 -3 50 -5 14 -10 20 -10 15z m6 -47 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z"/>
<path d="M4734 3317 c4 -32 2 -38 -10 -33 -9 3 -25 6 -36 6 -18 0 -19 2 -7 18
7 9 1 6 -13 -8 -14 -14 -26 -27 -26 -30 0 -44 -6 -65 -27 -86 -22 -21 -33 -25
-78 -22 l-52 3 0 51 c-1 42 2 51 14 46 8 -3 12 -1 8 5 -4 5 6 16 21 23 23 11
24 14 8 18 -10 2 -23 -1 -29 -7 -6 -6 -18 -11 -26 -11 -14 0 -14 2 -1 10 8 5
11 12 8 16 -4 3 -27 -5 -51 -19 -84 -50 -98 -157 -26 -205 28 -20 43 -23 84
-19 28 3 64 13 82 23 31 18 33 18 45 1 11 -14 24 -18 58 -15 40 3 45 6 47 28
2 14 8 66 14 116 9 70 8 96 -1 110 -9 16 -10 13 -6 -19z"/>
<path d="M4523 3323 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5214 3285 c16 -16 30 -20 22 -6 -4 5 0 12 6 14 7 3 0 6 -15 6 -25 1
-27 -1 -13 -14z"/>
<path d="M4588 3283 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5575 3283 c-57 -16 -77 -48 -91 -145 -16 -115 -2 -120 289 -111 219
6 219 6 243 32 14 14 27 37 29 51 3 14 9 43 14 65 10 44 -5 87 -36 100 -22 9
-420 16 -448 8z m103 -85 c-2 -7 -14 -15 -27 -18 -52 -11 -52 -61 1 -64 36 -2
29 -30 -9 -34 -60 -6 -96 66 -56 110 19 21 95 26 91 6z m122 -7 c15 -29 12
-72 -7 -93 -40 -44 -121 -4 -109 55 9 44 24 57 67 57 28 0 41 -5 49 -19z m208
-49 c3 -61 2 -63 -20 -60 -19 2 -23 10 -26 46 -4 57 -22 54 -22 -4 0 -41 -2
-45 -22 -42 -19 2 -24 10 -26 46 -3 38 -20 60 -24 30 0 -7 -2 -17 -3 -23 -2
-5 -3 -20 -4 -32 -1 -16 -7 -23 -21 -23 -18 0 -20 7 -20 65 l0 65 93 -2 92 -3
3 -63z m-464 -18 c14 -5 24 -34 12 -34 -2 0 -11 -3 -19 -6 -15 -5 -31 21 -21
37 6 11 8 11 28 3z"/>
<path d="M5736 3173 c-12 -13 -6 -53 9 -53 9 0 15 9 15 24 0 26 -12 40 -24 29z"/>
<path d="M2045 2775 c5 -11 9 -30 9 -42 1 -13 5 -23 10 -23 11 0 -1 62 -16 75
-8 7 -9 5 -3 -10z"/>
<path d="M3161 2780 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5
13 -9 14 -9 5z"/>
<path d="M4760 2772 c6 -13 14 -21 18 -18 3 4 -2 14 -12 24 -18 16 -18 16 -6
-6z"/>
<path d="M2590 2761 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M3550 2761 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M2937 2754 c-14 -14 -7 -35 11 -32 9 2 17 10 17 17 0 16 -18 25 -28
15z"/>
<path d="M3704 2740 c0 -11 4 -20 8 -20 4 0 8 9 8 20 0 11 -4 20 -8 20 -4 0
-8 -9 -8 -20z"/>
<path d="M4966 2743 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M2270 2740 c-13 -8 -13 -11 -1 -22 8 -8 11 -8 7 -1 -3 6 0 13 6 16 7
2 11 7 8 10 -3 3 -12 2 -20 -3z"/>
<path d="M4617 2736 c-4 -10 -5 -21 -2 -24 9 -9 17 6 13 25 -3 17 -4 17 -11
-1z"/>
<path d="M3140 2699 c-22 -18 -22 -19 -3 -10 12 6 25 16 28 21 9 15 3 12 -25
-11z"/>
<path d="M3836 2688 c6 -10 45 -10 61 0 6 4 -5 7 -27 7 -21 0 -36 -3 -34 -7z"/>
<path d="M4667 2143 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M4580 2049 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4580 2020 c0 -5 5 -10 11 -10 5 0 8 -4 5 -9 -9 -14 24 -22 45 -11
25 14 24 20 -1 15 -13 -2 -20 2 -20 11 0 8 -9 14 -20 14 -11 0 -20 -4 -20 -10z"/>
</g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
